package com.tedd.db

import kotlin.Long
import kotlin.String

public data class SelectLastAnswers(
  public val conversation_id: String,
  public val content: String,
  public val created_at: Long,
)
